// Lib
import React from 'react';
import { pure } from '../../../node_module_clones/recompose';
import { useSelector } from 'react-redux';

// Utils
import { isPlatformIframe } from '../../platform/utils/platformDetailsUtils';

// Selectors
import { isGuestSelector } from '../../user/currentUserSelector';
import { getPlatformDetailsSelector } from '../../platform/platformSelector';
import { selectVisibleConnectionStatus } from '../../offline/visibleConnectionStatus/visibleConnectionStatusSelector';

// Components
import LogoSpinner from '../loaders/LogoSpinner';

// Types
import { VisibleConnectionStatus } from '../../offline/visibleConnectionStatus/visibleConnectionStatusTypes';

// Styles
import './SocketConnectionStatusError.scss';

/**
 * Shows the "reconnecting" spinner if the app has been disconnected from web sockets for a period of time.
 */
const SocketConnectionStatusError = () => {
    const platformDetails = useSelector(getPlatformDetailsSelector);
    const isGuest = useSelector(isGuestSelector);
    const visibleConnectionStatus = useSelector(selectVisibleConnectionStatus);

    const isIframe = isPlatformIframe(platformDetails);
    const visibleStatusIsDisconnected = visibleConnectionStatus === VisibleConnectionStatus.disconnected;

    const shouldShowSpinner = visibleStatusIsDisconnected && !isGuest && !isIframe;

    if (!shouldShowSpinner) return null;

    return (
        <div className="SocketConnectionStatusError">
            <LogoSpinner />
        </div>
    );
};

export default pure(SocketConnectionStatusError);
